 <template>
  <div class="text-center">
    <v-dialog
      v-model="getShowUnsavedChangesModal"
      width="800"
      persistent
    >
      <v-card>
        <v-img
          :src="require('@/assets/LeaveConfirm.svg')"
          class="my-3"
          contain
          height="325"
        />
        <v-card-text>
            <h1>{{ $t('forms.saveChanges?') }}</h1>
            <p>{{ $t('story.basicInfoForm.unsavedDraftStory')}}</p>
            <v-row>
              <v-col>
                <v-btn
                  color="accentElementBackground"
                  @click="modalLeaveResponse"
                > {{ $t('forms.leaveWithoutSaving')}} </v-btn>
              </v-col>
              <v-col>
                <v-btn color="accent" @click="modalSaveResponse"
                > {{ $t('forms.save')}} </v-btn>
              </v-col>
            </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('formNavGuard', ['getShowUnsavedChangesModal'])
  },
  methods: {
    ...mapActions('formNavGuard', ['modalSaveResponse', 'modalLeaveResponse'])
  }
}
</script>

<style scoped>
h1, p { 
  line-height: 2;
}
</style>